var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3406,
    height: 2369,
    viewBox: "0 0 3406 2369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "7_128",
    d: "M778.269 677.99L1049.57 503.594L1176.63 698.464L906.713 873.698L778.269 677.99Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "7_129",
    d: "M906.767 872.99L1178.06 698.594L1305.13 893.464L1035.21 1068.7L906.767 872.99Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "7_125",
    d: "M581.767 1084.99L853.063 910.594L980.128 1105.46L710.211 1280.7L581.767 1084.99Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "7_124",
    d: "M710.171 1280.99L980.576 1105.58L1098.52 1286.04L828.602 1461.28L710.171 1280.99Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "7_123",
    d: "M965.065 1668.8L828.757 1460.99L1098.6 1286.1L1183.55 1412.27L1184.1 1413.09L1184.92 1412.55L1198.58 1403.61L1249.5 1483.92L965.065 1668.8Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "7_130",
    d: "M1421.11 1070.73L1559.97 1283.7L1266.05 1474.52L1214.27 1394.53L1232.9 1383.07L1233.77 1382.53L1233.22 1381.68L1147.75 1248.01L1421.11 1070.73Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "7_126",
    d: "M453.767 889.99L725.063 715.594L852.128 910.464L582.211 1085.7L453.767 889.99Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "7_127",
    d: "M288.203 631.704L881.818 248.55L1048.66 503.724L454.673 889.829L288.203 631.704Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "7_115",
    d: "M1911.38 1311.71H1995.67H2142.38V1633.71H2047.92H1911.38V1311.71Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "7_114",
    d: "M1680.38 1417.21V1311.71H1764.67H1911.38V1633.71H1816.92H1673.88V1546.71V1545.71H1672.88H1656.38V1418.21H1679.38H1680.38V1417.21Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "7_116",
    d: "M2142.38 1311.71H2230.33H2383.38V1633.71H2284.82H2142.38V1311.71Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "7_117",
    d: "M2383.38 1311.71H2490H2675.38V2020.71H2555.93H2383.38V1311.71Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "7_118",
    d: "M2142.38 1698.71H2230.33H2383.38V2020.71H2284.82H2142.38V1698.71Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "7_119",
    d: "M1911.38 1698.71H1995.67H2142.38V2020.71H2047.92H1911.38V1698.71Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "7_120",
    d: "M1679.38 1698.71H1764.04H1911.38V2020.71H1816.51H1679.38V1698.71Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "7_121",
    d: "M1447.38 1698.71H1532.04H1679.38V2020.71H1584.51H1447.38V1698.71Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "7_122",
    d: "M1383.88 1699.71H1445.38V2020.71H1350.51H1224.43C1201.98 2020.71 1181.08 2009.31 1168.93 1990.44L968.761 1679.52L1208.59 1526.09L1307.04 1675.27L1307.58 1676.08L1308.41 1675.56L1351.07 1648.59L1383.03 1699.25L1383.33 1699.71H1383.88Z",
    fill: "#A0BA3B",
    fillOpacity: 0.38,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor7);
export default __webpack_public_path__ + "static/media/select_floor_7.7147ff3707fbd521b44f82351289735f.svg";
export { ForwardRef as ReactComponent };